module.exports = __webpack_public_path__ + "img/px.53bb7ce7.jpg";